import { render, staticRenderFns } from "./DocumentSelector.vue?vue&type=template&id=fed6b290&scoped=true&"
import script from "./DocumentSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSelector.vue?vue&type=style&index=0&id=fed6b290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed6b290",
  null
  
)

export default component.exports